<template>
  <b-card
    bg-variant="dark"
    :header="task.title"
    text-variant="white"
    class="text-center"
    style="margin-bottom: 10px"
  >
    <b-card-body>
      <b-button class="add-crew-btn" size="sm" @click="">I'll do it </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from "moment";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  components: { TipTapOutput },
  props: {
    resource: {
      type: Object,
      default: () => {},
      required: false
    },
    task: {
      type: Object,
      default: () => {},
      required: false
    }
  },
  methods: {
    formattedDate(date) {
      //@TODo - Date format should be standardized even for apps
      return moment(new Date(date.toDate())).format("dddd, DD MMMM YYYY");
    }
    /* EMITTERS */
  },
  computed: {
    userDataTasksNeedsHelp() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "needs_help";
        })
      );
    },
    userDataTasksNotStarted() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "not_started";
        })
      );
    },
    userDataTasksStarted() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "started";
        })
      );
    },
    userDataTasksDone() {
      return (
        this.tasks &&
        Array.isArray(this.tasks) &&
        this.tasks.filter(aTask => {
          return aTask.status === "done";
        })
      );
    }
  },
  data() {
    return {
      production: true,
      fields: [
        {
          key: "task",
          sortable: true,
          label: "Task"
        },
        {
          key: "note",
          sortable: true,
          label: "Notes"
        },
        {
          key: "_created_at",
          sortable: true,
          label: "Last Update"
        }
      ],
      tableVariants: [
        "primary",
        "secondary",
        "info",
        "danger",
        "warning",
        "success",
        "light",
        "dark"
      ],
      striped: true,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: true,
      headVariant: null,
      tableVariant: "",
      noCollapse: false
    };
  }
};
</script>
